module.exports = __webpack_public_path__ + "static/media/22.076af6a6.JPG";